import { IntegrationVendor } from '../../models/enums/integrationEnums';
import { Checkbox } from 'primereact/checkbox';

interface VendorOverrideFieldsProps {
  vendor: string;
  overrideValues: Record<string, string>;
  onValueChange: (field: string, value: string) => void;
  overrideMode?: boolean;
  overrideFlags?: Record<string, boolean>;
  onOverrideFlagChange?: (field: string, checked: boolean) => void;
}

export const VendorOverrideFields = ({ 
  vendor, 
  overrideValues, 
  onValueChange,
  overrideMode = false,
  overrideFlags = {},
  onOverrideFlagChange
}: VendorOverrideFieldsProps) => {
  
  const renderField = (
    id: string,
    label: string,
    fieldKey: string,
    placeholder: string,
    type: string = 'text'
  ) => {
    const isOverridden = overrideFlags[fieldKey] || false;
    const isDisabled = overrideMode && !isOverridden;

    return (
      <div className="field mb-4">
        <div className="flex align-items-center justify-content-between mb-2">
          <label htmlFor={id}>{label}</label>
          {overrideMode && onOverrideFlagChange && (
            <div className="flex align-items-center gap-2">
              <Checkbox
                inputId={`${id}-override`}
                checked={isOverridden}
                onChange={(e) => onOverrideFlagChange(fieldKey, e.checked || false)}
              />
              <label htmlFor={`${id}-override`} className="text-sm mb-0">Override?</label>
            </div>
          )}
        </div>
        <input
          id={id}
          type={type}
          value={overrideValues[fieldKey] || ''}
          onChange={(e) => onValueChange(fieldKey, e.target.value)}
          className="p-inputtext p-component"
          placeholder={placeholder}
          disabled={isDisabled}
        />
      </div>
    );
  };

  return (
    <>
      {/* RatesBoard - Branch Code */}
      {vendor === IntegrationVendor.RatesBoard && (
        <>
          {renderField('branchCode', 'Branch Code', 'branchCode', 'Enter branch code')}
        </>
      )}

      {/* Truv - Template ID, Client ID, Access Key */}
      {vendor === IntegrationVendor.Truv && (
        <>
          {renderField('templateId', 'Template ID', 'templateId', 'Enter template ID')}
          {renderField('clientId', 'Client ID', 'clientId', 'Enter client ID')}
          {renderField('accessKey', 'Access Key', 'accessKey', 'Enter access key')}
        </>
      )}

      {/* Argyle - API Key, API Secret */}
      {vendor === IntegrationVendor.Argyle && (
        <>
          {renderField('apiKey', 'API Key', 'apiKey', 'Enter API key')}
          {renderField('apiSecret', 'API Secret', 'apiSecret', 'Enter API secret')}
        </>
      )}

      {/* Equifax - User ID, Password */}
      {vendor === IntegrationVendor.Equifax && (
        <>
          {renderField('signOnRequestUserId', 'Sign-On Request User ID', 'signOnRequestUserId', 'Enter user ID')}
          {renderField('signOnRequestUserPassword', 'Sign-On Request User Password', 'signOnRequestUserPassword', 'Enter password', 'password')}
        </>
      )}

      {/* Vesta - Base URL, API Key */}
      {vendor === IntegrationVendor.Vesta && (
        <>
          {renderField('baseUrl', 'Base URL', 'baseUrl', 'Enter base URL')}
          {renderField('vestaApiKey', 'API Key', 'apiKey', 'Enter API key')}
        </>
      )}

      {/* Snap - Account ID, Site ID, Product ID */}
      {vendor === IntegrationVendor.Snap && (
        <>
          {renderField('accountId', 'Account ID', 'accountId', 'Enter account ID')}
          {renderField('siteId', 'Site ID', 'siteId', 'Enter site ID')}
          {renderField('productId', 'Product ID', 'productId', 'Enter product ID')}
        </>
      )}

      {/* FannieMae - Lender ID */}
      {vendor === IntegrationVendor.FannieMae && (
        <>
          {renderField('lenderId', 'Lender ID', 'lenderId', 'Enter lender ID')}
        </>
      )}

      {/* SmartFees - API Key, Password, User ID, URL Override */}
      {vendor === IntegrationVendor.SmartFees && (
        <>
          {renderField('apiKey', 'API Key', 'apiKey', 'Enter API key', 'password')}
          {renderField('password', 'Password', 'password', 'Enter password', 'password')}
          {renderField('userId', 'User ID', 'userId', 'Enter user ID')}
          {renderField('urlOverride', 'URL Override', 'urlOverride', 'Enter URL override (optional)')}
        </>
      )}

      {/* Ernst - Username, Password */}
      {vendor === IntegrationVendor.Ernst && (
        <>
          {renderField('username', 'Username', 'username', 'Enter username')}
          {renderField('password', 'Password', 'password', 'Enter password', 'password')}
        </>
      )}

      {/* Truework - Access Key, Webhook Token */}
      {vendor === IntegrationVendor.Truework && (
        <>
          {renderField('accessKey', 'Access Key', 'accessKey', 'Enter access key', 'password')}
          {renderField('webhookToken', 'Webhook Token', 'webhookToken', 'Enter webhook token', 'password')}
        </>
      )}

      {/* Factual - App Key, Username, Password */}
      {vendor === IntegrationVendor.Factual && (
        <>
          {renderField('appKey', 'App Key', 'appKey', 'Enter app key')}
          {renderField('username', 'Username', 'username', 'Enter username')}
          {renderField('password', 'Password', 'password', 'Enter password', 'password')}
        </>
      )}
    </>
  );
};
